var React = require('react');

function Tr (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"1200","height":"800","fill":"#E30A17","key":0}),React.createElement("circle",{"cx":"425","cy":"400","r":"200","style":{"fill":"#ffffff"},"key":1}),React.createElement("circle",{"cx":"475","cy":"400","r":"160","style":{"fill":"#E30A17"},"key":2}),React.createElement("polygon",{"style":{"fill":"#ffffff"},"points":"583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221","key":3})]);
}

Tr.defaultProps = {"viewBox":"0 0 1200 800"};

module.exports = Tr;

Tr.default = Tr;
